import { action } from 'satcheljs';
import type { HeaderPaneName } from 'owa-app-pane-group-types';
import type { HeaderPaneActionMessage } from '../types/HeaderPaneActionMessage';

export const onCloseHeaderPane: (
    headerPaneName: HeaderPaneName,
    targetWindow?: Window
) => HeaderPaneActionMessage = action(
    'onCloseHeaderPane',
    (headerPaneName: HeaderPaneName, targetWindow: Window = window): HeaderPaneActionMessage => ({
        headerPaneName,
        targetWindow,
    })
);
